import { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import ApiServices from "../services/apiservices";

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPosts = async () => {
    try {
      const res = await ApiServices.getRequest("/posts/published.php?limit=10");

      if (res.success) {
        const formatted = res.posts.map((post) => {
          const date = new Date(post.createdAt);

          return {
            id: post.id,
            title: post.title,
            link: post.postLinkTitle,
            category: post.category,
            image: post.category === "Tender Notice" ? "/images/tender-notice.jpeg" : post.featuredImage,
            day: date.toLocaleString("en-US", { day: "2-digit" }),
            month: date.toLocaleString("en-US", { month: "short" }).toUpperCase(),
          };
        });

        setBlogs(formatted.slice(0, 6));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  if (loading) {
    return (
      <section className="py-12 text-center bg-white flex flex-col items-center justify-center">
        <div className="w-10 h-10 border-4 border-green-700 border-t-yellow-400 rounded-full animate-spin mb-3"></div>
        <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">Syncing latest news...</p>
      </section>
    );
  }

  return (
    <section className="bg-white py-12">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">

        {/* HEADER ROW */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-6">

          <div className="max-w-2xl">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-1 bg-yellow-400 rounded-full"></div>
              <span className="text-green-700 font-bold tracking-widest text-[10px] uppercase">Corporate Press</span>
            </div>

            <h2 className="text-2xl md:text-3xl font-extrabold text-black mb-4 uppercase tracking-tight leading-tight">
              Pub<span className="text-green-700">lica</span>tions
            </h2>

            <p className="text-gray-600 text-sm md:text-base font-medium leading-relaxed border-l-4 border-yellow-400 pl-4">
              Stay updated with the latest developments, news, and official
              announcements from BEDC. Powering our community with information.
            </p>
          </div>

          <div className="mt-4 md:mt-0">
            <Link to="/publications">
              <button className="group relative overflow-hidden bg-black text-white px-6 py-3 rounded-xl text-[10px] font-bold uppercase tracking-wider transition-all hover:bg-green-700 shadow-md">
                <span className="relative z-10 flex items-center gap-2">
                  ALL PUBLICATIONS
                  <FiChevronRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
            </Link>
          </div>
        </div>

        {/* BLOG GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((blog) => (
            <div key={blog.id} className="group flex flex-col bg-white rounded-2xl border border-gray-100 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden">

              <div className="relative overflow-hidden aspect-[16/9]">
                {blog.image ? (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 font-bold text-[10px]">No Image</div>
                )}

                {/* DATE BADGE */}
                <div className="absolute top-3 left-3 bg-yellow-400 text-black px-3 py-2 rounded-xl text-center shadow">
                  <p className="text-base font-extrabold leading-none mb-0.5">{blog.day}</p>
                  <p className="text-[8px] font-extrabold uppercase tracking-widest">{blog.month}</p>
                </div>

                <div className="absolute inset-0 bg-green-700/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* CONTENT */}
              <div className="p-5 flex flex-col flex-grow justify-between">
                <div>
                  <Link to={`/${blog.link}`}>
                    <h4 className="text-sm md:text-base font-bold text-gray-900 mb-4 line-clamp-2 group-hover:text-green-700 transition-colors uppercase leading-snug tracking-tight">
                      {blog.title}
                    </h4>
                  </Link>
                </div>

                <div className="mt-4 pt-3 border-t border-gray-100">
                  <Link to={`/${blog.link}`} className="inline-block group/btn">
                    <div className="flex items-center gap-3 text-[10px] font-bold tracking-wider text-green-700 uppercase">
                      <span className="relative">
                        READ ARTICLE
                        <span className="absolute -bottom-1 left-0 w-6 h-[2px] bg-yellow-400 transition-all duration-300 group-hover/btn:w-full"></span>
                      </span>
                      <div className="bg-gray-50 p-2 text-black rounded-lg transition-all group-hover/btn:bg-yellow-400 group-hover/btn:scale-105">
                        <FiChevronRight size={12} />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;